import React, { Component } from "react";
import { POST, loading, alert, t } from "../components/CustomComponent.js";
import Language from "../components/Language.js";
import SNAPA from "../assets/images/snapa.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
import { clearStorageKeepLang } from "../utils/backendMessage";

// เกณฑ์ความยาวรหัสผ่านใหม่ — ต้องตรงกับ ChangePasswordDto ฝั่ง backend (modules/auth/dtos/request/change-password.dto.js)
const PASSWORD_MIN = 6;

/**
 * หน้าบังคับเปลี่ยนรหัสผ่านครั้งแรก / เมื่อ backend ตอบ 403 "Password change required"
 *
 * เข้าได้ 2 ทาง:
 * 1) login.js เด้งมาตรงนี้เมื่อ result.data.must_change_password === true (token/profile ถูกเก็บไว้แล้ว)
 * 2) services/api.js handleResponse เด้งมาเมื่อ endpoint อื่นตอบ 403 "Password change required"
 *    ระหว่างที่ user_type ยัง must_change_password อยู่ (ไม่ล้าง session ตอนเด้งมา)
 *
 * สำเร็จแล้ว backend ล้าง token ให้อัตโนมัติ (เตะออกทุกอุปกรณ์) หน้านี้จึงล้าง localStorage แล้วพากลับหน้า login
 */
export default class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current_password: "",
      new_password: "",
      confirm_new_password: "",
      submitting: false,
    };
  }

  componentDidMount() {
    // ต้องมี token อยู่ก่อนแล้วเท่านั้น (มาจาก login หรือถูกเด้งมาระหว่างใช้งาน) ไม่งั้นไม่มีทางยิง auth/change-password ได้
    if (!localStorage.getItem("cm-acc-tk")) {
      window.location.href = "/";
      return;
    }
    loading(false);
  }

  Submit = async () => {
    const { current_password, new_password, confirm_new_password, submitting } = this.state;
    if (submitting) return;

    if (!current_password) {
      alert("", "warning", t("warning"), t("verify_current_password"));
      return;
    }
    if (!new_password) {
      alert("", "warning", t("warning"), t("verify_new_password"));
      return;
    }
    if (new_password.length < PASSWORD_MIN) {
      alert("", "warning", t("warning"), t("verify_password_too_short").replace("{min}", PASSWORD_MIN));
      return;
    }
    if (!confirm_new_password) {
      alert("", "warning", t("warning"), t("verify_confirm_new_password"));
      return;
    }
    if (new_password !== confirm_new_password) {
      alert("", "warning", t("warning"), t("verify_password_mismatch"));
      return;
    }
    if (new_password === current_password) {
      alert("", "warning", t("warning"), t("verify_password_same_as_current"));
      return;
    }

    this.setState({ submitting: true });
    loading(true);

    // password เข้ารหัส base64 ก่อนส่งเสมอ เหมือน login.js (ดู ChangePasswordDto)
    const result = await POST("auth/change-password", {
      current_password: btoa(current_password),
      new_password: btoa(new_password),
    });

    if (result?.status === true) {
      // backend เตะ token ออกทุกอุปกรณ์ให้แล้ว - ล้าง session ฝั่งนี้แล้วให้เข้าสู่ระบบใหม่
      clearStorageKeepLang();
      alert("/", "success", t("change_password_success_title"), t("change_password_success_desc"));
    } else {
      this.setState({ submitting: false });
      alert("", "warning", t("warning"), result?.message || "An error occurred.");
    }
    loading(false);
  };

  render() {
    const { current_password, new_password, confirm_new_password, submitting } = this.state;

    return (
      <div
        className="w-100 min-vh-100 bg-light d-flex align-items-center justify-content-center position-relative"
        style={{ backgroundColor: "#f4f7f9" }}
      >
        <div className="position-absolute top-0 end-0 p-4">
          <Language />
        </div>

        <div
          className="card shadow-lg border-0 rounded-4 p-4 p-md-5"
          style={{ maxWidth: "480px", width: "90%" }}
        >
          <div className="text-center mb-4">
            <img src={SNAPA} alt="Service Vibrations Logo" style={{ width: "120px" }} className="mb-3" />
            <h3 className="fw-bold">{t("change_password_title")}</h3>
            <p className="text-muted">{new URLSearchParams(window.location.search).get("from") === "menu" ? t("change_password_voluntary_desc") : t("change_password_first_login_desc")}</p>
          </div>

          {/* Current password */}
          <div className="mb-3">
            <label className="form-label small fw-bold">{t("current_password")}</label>
            <input
              type="password"
              className="form-control"
              value={current_password}
              onChange={(e) => this.setState({ current_password: e.target.value })}
            />
          </div>

          {/* New password */}
          <div className="mb-3">
            <label className="form-label small fw-bold">{t("new_password")}</label>
            <input
              type="password"
              className="form-control"
              value={new_password}
              onChange={(e) => this.setState({ new_password: e.target.value })}
            />
          </div>

          {/* Confirm new password */}
          <div className="mb-4">
            <label className="form-label small fw-bold">{t("confirm_new_password")}</label>
            <input
              type="password"
              className="form-control"
              value={confirm_new_password}
              onChange={(e) => this.setState({ confirm_new_password: e.target.value })}
              onKeyUp={(e) => e.key === "Enter" && this.Submit()}
            />
          </div>

          <button
            className="btn btn-primary w-100 py-2 fw-bold shadow-sm"
            onClick={this.Submit}
            disabled={submitting}
          >
            {t("change_password_submit")}
          </button>
        </div>
      </div>
    );
  }
}
